import { Component, EventEmitter, Input, Output, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-archive-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './archive-button.component.html',
  styleUrl: './archive-button.component.css',
  host: {
    '[attr.data-no-row-click]': '"true"'
  }
})
export class ArchiveButtonComponent {
  @Input() archived: boolean = false;
  @Input() loading: boolean = false;
  @Input() disabled: boolean = false;
  @Input() archiveTitle?: string;
  @Input() unarchiveTitle?: string;

  @Output() toggle = new EventEmitter<MouseEvent>();

  constructor(@Optional() private translate?: TranslateService) {}

  onClick(event: MouseEvent): void {
    event.stopPropagation();
    if (!this.disabled && !this.loading) {
      this.toggle.emit(event);
    }
  }

  get tooltip(): string {
    if (this.archived) {
      return this.unarchiveTitle || this.translate?.instant('ACTIONS.UNARCHIVE') || 'Désarchiver';
    }
    return this.archiveTitle || this.translate?.instant('ACTIONS.ARCHIVE') || 'Archiver';
  }
}
